
<style lang="less">
@import "./AppMain.less";
</style>

<template>
  <div class="app-main-container">
    <div class="bread-crumb-container">
      <Breadcrumb />
    </div>
    <section class="app-main">
      <div class="app-container">
        <transition name="fade-transform" mode="out-in">
          <router-view ref="rv" :key="key" />
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  name: 'AppMain',
  components: {
    Breadcrumb
  },
  data() {
    return {
      key: this.$router.currentRoute.fullPath
    }
  }
}
</script>


